/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Check if string corresponds to valid JS Date.
 */
export const isValidDate = (dateString: string): boolean => {
  if (!dateString) {
    return false;
  }

  const date = new Date(dateString);

  return date instanceof Date && !isNaN(date.getTime());
};
